module.exports = __webpack_public_path__ + "img/b.2c056b43.jpg";